/* eslint-disable */

// 支部工作计划-表单
export const branchWorkPlanForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        border: true,
        rules: {},
    },
    items: [
        {
            type: 'file-upload',
            label: '支部工作计划',
            text: '上传',
            btnType: 'primary',
            prop: 'branchWorkPlan',
        },
    ],
}

// 支部工作总结 - 表单
export const branchWorkSummaryForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        border: true,
        rules: {},
    },
    items: [
        {
            type: 'file-upload',
            label: '支部工作总结',
            text: '上传',
            btnType: 'primary',
            prop: 'branchWorkSummary',
        },
    ],
}
